import { makeStyles } from "@material-ui/core/styles";
import { useContext } from "react";
import { ThemeContext } from "../../Context/Theme";
export const useModalStyles = (top, topMobile, height, width, minHeight) => {
  const { dark } = useContext(ThemeContext);
  const useStyles = makeStyles((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflowY:"scroll"
    },
    paper: {
      margin: "10px 20px",
      top: top,
      [theme.breakpoints.down("md")]: {
        top: topMobile,
      },
      backgroundColor: dark ? "#212121" : "#f2f2f2",
      border: "1px solid #f2f2f2",
      borderRadius: 0,
      boxShadow: theme.shadows[5],
      position:"absolute",
      padding: theme.spacing(2, 4, 3),
      height: height && height,
      minHeight: minHeight && minHeight,
      width: width && width,
    },
  }));

  const classes = useStyles();
  return classes;
};
